import { default as tilebelt } from '@mapbox/tilebelt'

function divmod(a, b) {
  let remainder = a % b;
  let aIsInfinite = a === -Infinity || a === Infinity;
  let bIsInfinite = b === -Infinity || b === Infinity;
  let aIsNeg = a + 1 / a < 0;
  let bIsNeg = b + 1 / b < 0;
  return [
    (aIsInfinite !== bIsInfinite && a) ? aIsInfinite ? NaN : aIsNeg === bIsNeg ? 0 : -1 : Math.floor(a / b),
    (!a && b < 0) ? -0 : remainder + (remainder !== 0 && aIsNeg !== bIsNeg ? b : 0)
  ];
}

function Base58Encode(value) {

    const _NEGATIVE = "Z";
    const _CHARS = "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXY";
    const _CHAR_NUM = _CHARS.length;

    let div, encoded, mod;
    if (value < 0) {
      encoded = "Z";
      value = -value;
    } else {
      encoded = "";
    }
    while (value >= _CHAR_NUM) {
      [div, mod] = divmod(value, _CHAR_NUM);
      encoded = _CHARS[mod] + encoded;
      value = div;
    }
    return _CHARS[value] + encoded;
}

export const lnglat2quadkey = (lng, lat) => tilebelt.tileToQuadkey(
      tilebelt.pointToTile(lng, lat, 18)
  )

export const quadkey2int = (quadkey) => {
  let integer = 0
  for (c of quadkey){
    integer = 5 * integer + (Number.parseInt(c) + 1)
  }
  return integer
}


export const lnglat2quadhash = (lng, lat) => Base58Encode(quadkey2int(lnglat2quadkey(lng, lat)))
